<div class="po-component-container calc-width">
<div class="d-flex justify-content-center align-items-center mt-2" >
  <div class="row">
    <div class="col-12 col-sm-4 mb-3">
      <mat-card
        (click)="onInventoryManagement()"
        class="click-behaviour p-5"
        style="border-radius: 10px; height: 200px; width: 200px; cursor: pointer; background-color: #F5F5F5">

        <div class="text-center p-2">
          <i class="las la-suitcase" style="font-size: 40px; color: #09D1A6"></i>
        </div>
        <div class="text-center">
          <h4 class="text-uppercase">Inventory Management </h4>
        </div>
      </mat-card>
    </div>

    <div class="col-12 col-sm-4 mb-3">
      <mat-card
        (click)="onRestaurantManagement()"
        class="click-behaviour p-5"
        style="border-radius: 10px; height: 200px; width: 200px; cursor: pointer; background-color: #F5F5F5">

        <div class="text-center p-2">
          <i class="las la-utensils" style="font-size: 40px; color: #7A2BD3"></i>
        </div>
        <div class="text-center">
          <h4 class="text-uppercase"> Restaurant Management </h4>
        </div>
      </mat-card>
    </div>

    <div class="col-12 col-sm-4 mb-3">
      <mat-card
        (click)="onMenuManagement()"
        class="click-behaviour p-5"
        style="border-radius: 10px; height: 200px; width: 200px; cursor: pointer; background-color: #F5F5F5">

        <div class="text-center p-2">
          <i class="lab la-buffer" style="font-size: 40px; color: #7A2BD3"></i>
        </div>
        <div class="text-center">
          <h4 class="text-uppercase"> Menu Management </h4>
        </div>
      </mat-card>
    </div>

    <div class="col-12 col-sm-4 mb-3">
      <mat-card
        (click)="onUserManagement()"
        class="click-behaviour p-5"
        style="border-radius: 10px; height: 200px; width: 200px; cursor: pointer; background-color: #F5F5F5">

        <div class="text-center p-2">
          <i class="las la-user" style="font-size: 40px; color: #7A2BD3"></i>
        </div>
        <div class="text-center">
          <h4 class="text-uppercase"> User Management </h4>
        </div>
      </mat-card>
    </div>
    <div class="col-12 col-sm-4 mb-3">
      <mat-card
        (click)="onSystemSettings()"
        class="click-behaviour p-5"
        style="border-radius: 10px; height: 200px; width: 200px; cursor: pointer; background-color: #F5F5F5">

        <div class="text-center p-2">
          <i class="las la-cog" style="font-size: 40px; color: #7A2BD3"></i>
        </div>
        <div class="text-center">
          <h4 class="text-uppercase"> System Settings</h4>
        </div>
      </mat-card>
    </div>
  </div>
</div>
</div>
